import { ExclamationIcon } from '@heroicons/react/solid'

type ErrorBoxType =  {
  message: string
}

export default function ErrorBox({ message }: ErrorBoxType) {

  return (
    <div className="rounded-md bg-yellow-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationIcon className="h-5 w-5 text-yellow-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">Ocurrió un error</h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p>{ message }</p>
          </div>
        </div>
      </div>
    </div>
  )
}